import React from 'react'
import PropTypes from 'prop-types'
import { Alert, AlertTitle } from '@material-ui/lab'
import { Container } from './styles'

export default function ApiErrors({ responseError }) {
  const renderError = (error, index) => (
    <li key={`error-message-${index}`}>{error}</li>
  )

  if (!responseError || !responseError.error) return null

  if (responseError.errors?.length) {
    return (
      <Container>
        <Alert severity="error">
          <AlertTitle>{responseError.message}</AlertTitle>
          <ul>
            {responseError.errors.map((error, index) => renderError(error, index))}
          </ul>
        </Alert>
      </Container>
    )
  }

  return (
    <Container>
      <Alert severity="error">
        <AlertTitle>{responseError.message}</AlertTitle>
      </Alert>
    </Container>
  )
}

ApiErrors.propTypes = {
  responseError: PropTypes.objectOf(PropTypes.any),
}

ApiErrors.defaultProps = {
  responseError: {},
}
